import { useEffect, useRef } from 'react';
import { Container, Sprite } from '@pixi/react';
import { BoostedJackpotDate } from '../../boostedJackpotDate';
import { BoostedJackpotIconViewProps } from '../../index.types';
import { isMobile } from '../../../../../../helpers';
import { Spine } from '../../../../../components';

export const BoostedJackpotIconView: React.FC<BoostedJackpotIconViewProps> = ({
  animationName,
  handlePointerUp,
  boostedJackpotIconInfoBoard,
  isDisabled
}) => {
  const iconBoardRef: any = useRef(null);  
  useEffect(() => {
    if (iconBoardRef.current) {
      const wheelIcon: Spine = new Spine({ key: 'wheelIcon' });
      iconBoardRef.current.addChild(wheelIcon);

    }
  }, [iconBoardRef]);

  useEffect(() => {
    const iconBoard = iconBoardRef.current;
    const iconSpine = iconBoard?.children?.[0];
    if (!iconSpine) return;

    iconSpine.stop();
    iconSpine.play(animationName, true);
  }, [animationName]);

  return (
    <Container
      interactive={true}
      cursor='pointer'
      {...({ name: 'BoostedJackpotIcon' } as any)}
      pointerup={handlePointerUp}
    >
      <Container ref={iconBoardRef} />
      <Container y={isMobile() ? 20 : 30}>
        <Sprite texture={boostedJackpotIconInfoBoard} anchor={0.5} />
        <BoostedJackpotDate
          x={-20}
          y={isMobile() ? -65 : -65}
          isIcon
          marginInText={10}
          marginInContainer={30}
          hiderTextXPosition={5}
          durationTextPositions={{ x: 126, y: 30 }}
          stylesTimer={{
            fontSize: isMobile() ? 10 : 14,
            align: 'center',
            fill: '#FFC33E',
            fontWeight: '600',
            fontFamily: 'poppinsMedium',
          }}
        />
      </Container>
    </Container>
  );
};
